import React, {Component} from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {Layout, Spin} from 'antd';
import MainRoute from "./routes/MainRoute";
import AppHeader from "./components/AppHeader";
import {getUserData, isAdminRole, isAuthenticated, logout} from "./services/UsersService";
import './styles/styles.css';
import ConnectionHistory from "./views/clients/ConnectionHistory";
import SocketActiveSessions from "./views/clients/SocketActiveSessions";
import ManagementRoute from "./routes/ManagementRoute";
import PasswordRecover from "./views/PasswordRecover";
import Profile from "./views/Profile";
import Invite from "./views/invite/Invite";

const {Content} = Layout;

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false
        };
        this.loadUser = this.loadUser.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        window.app = this;
    }

    handleLogin() {
        this.loadUser();
        this.props.history.push("/");
    }

    handleLogout() {
        logout();
        this.props.history.push("/");
        window.location.reload();
    }

    loadUser() {
        this.setState({
            isLoading: true
        });
        this.setState({
            userData: getUserData(),
            isAuthenticated: isAuthenticated(),
            isAdmin: isAdminRole(),
            isLoading: false
        });
    }

    componentWillMount() {
        this.loadUser();
    }

    render() {
        if (this.state.isLoading) {
            return <div className="main-spin-container"><Spin size="large"/></div>
        }
        return (
            <Layout className="app-container">
                <AppHeader isAuthenticated={this.state.isAuthenticated} userData={this.state.userData}
                           onLogout={this.handleLogout}/>
                <Content className="app-content">
                    <div className="container-main container">
                        <Switch>
                            <Route exact path="/" render={(props) => <MainRoute onLogin={this.handleLogin} {...this.state} />}/>
                            <Route path="/management/:client?" render={(props) => <ManagementRoute {...this.state} />}/>
                            <Route path="/server/connection-history" render={(props) => <ConnectionHistory/>}/>
                            <Route path="/server/socket-sessions" render={(props) => <SocketActiveSessions/>}/>
                            <Route path="/users/profile" render={(props) => <Profile onLogout={this.handleLogout}/>}/>
                            <Route path="/password_recover" render={(props) => <PasswordRecover/>}/>
                            <Route path="/public/invite/:id" render={(props) => <Invite id={props.match.params.id} {...this.state}/>}/>
                        </Switch>
                    </div>
                </Content>
            </Layout>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/app/App.js